module.exports = __webpack_public_path__ + "media/staff/sarai-visual-1-edited-b1ba0c8b.jpg";